import React from 'react';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withCurrentUser } from 'src/components/withCurrentUser';
import { MobileTitlebar } from 'src/components/titlebar';
import { ErrorBoundary } from 'src/components/error';
import { isViewingMarketingPage } from 'src/helpers/is-viewing-marketing-page';

const GlobalTitlebar = props => {
  const {
    title = 'Spectrum',
    titleIcon = null,
    rightAction = null,
    leftAction = 'menu',
    history,
    currentUser,
  } = props;

  if (isViewingMarketingPage(history, currentUser)) {
    return null;
  }

  return (
    <ErrorBoundary fallbackComponent={<MobileTitlebar title="Error" />}>
      <MobileTitlebar
        title={title}
        titleIcon={titleIcon}
        leftAction={leftAction}
        rightAction={rightAction}
      />
    </ErrorBoundary>
  );
};

const map = state => state.titlebar;

export default compose(
  withRouter,
  withCurrentUser,
  connect(map)
)(GlobalTitlebar);
